import { render, staticRenderFns } from "./FormTextAreaField.vue?vue&type=template&id=538e1a32&"
import script from "./FormTextAreaField.vue?vue&type=script&lang=js&"
export * from "./FormTextAreaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports